import { useQuery } from '@tanstack/react-query';

import { cutlistsApi } from '@/api/backend/cutlists';
import { nestingPollInterval, useMixedNestingStore } from '@/api/mixedNesting';

export const starterKeys = {
  getOne: (cutlistId: string) => ['starter-cutlist', cutlistId],
  nestingJobs: (cutlistId: string) => ['nesting-jobs', cutlistId],
};

export const getStarterCutlistQuery = (id: string) => ({
  queryKey: starterKeys.getOne(id),
  queryFn: () => cutlistsApi.getStarterCutlist(id),
});

export const usePollNestingJobs = (cutlistId: string) => {
  const polling = useMixedNestingStore((state) => state.polling);

  return useQuery({
    queryKey: starterKeys.nestingJobs(cutlistId),
    queryFn: () => cutlistsApi.pollNestingJobs(cutlistId),
    enabled: polling,
    gcTime: 0,
    refetchInterval: (query) => nestingPollInterval(query.state.data),
  });
};
